export const mapDate = (date?: string | number | null) => {
  return date ? new Date(date) : undefined;
};
